export enum LoginComponentScreen {
  'Register',
  'RegisterLifeBridge',
  'Login',
  'Reset',
  'Verify',
  'NewEmail',
}
